<template>
  <Modal
    :activeModal="activeModal"
    :widthModal="750"
    @closeModal="closeModal">
   <template v-slot:btnActivator>
    </template>
    <v-card>
      <v-toolbar flat height="40px" class="modal-cadastro-toolbar">
          {{ afiliado ? afiliado.jsonData.fullName : '' }}
          <v-spacer></v-spacer>
          <v-icon @click="closeModal" class="modal-cadastro-close">close</v-icon>
      </v-toolbar>
      <div class="abas" width="100%">
        <v-tabs
          v-model="tab"
          height="30px"
        >
          <v-tab href="#tab-1" class="abas-item" v-if="permiteAcao({ path: '/afiliados/afiliados/get-all-affiliates/'}, '')">
            Afiliado Ref.
          </v-tab>
          <v-tab href="#tab-2" class="abas-item">
            Contratos
          </v-tab>

          <v-tab href="#tab-3" class="abas-item">
            Referencia
          </v-tab>
        </v-tabs>
      </div>

      <v-tabs-items v-model="tab" touchless>
        <v-tab-item
          :key="1"
          :value="'tab-1'">
           <ParentAffiliate
            v-if="permiteAcao({ path: '/afiliados/afiliados/get-all-affiliates/'}, '')"
            :key="keyContratos"
            :disabled="afiliado.jsonFlags.pendingApprovalAffiliate"
            :affiliate="afiliado"
           />
        </v-tab-item>
        <v-tab-item
          :key="2"
          :value="'tab-2'">
          <Contratos 
            :affiliateId="+afiliado.affiliate.id"
            :key="keyContratos"
          />
        </v-tab-item>

        <v-tab-item
          :key="3"
          :value="'tab-3'">
           <Referencia 
            :affiliateId="+afiliado.affiliate.id"
            :key="keyContratos"
           />
        </v-tab-item>
      </v-tabs-items>

      <v-card-actions class="modal-cadastro-footer">
        <v-btn :color="variables.colorPrimary" @click="closeModal" class="br-btn br-btn-cancelar">Cancelar</v-btn>
        <v-btn :color="variables.colorPrimary" @click.prevent="submit" class="br-btn" :loading="loadingBtn">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { mask } from 'vue-the-mask'
import Events from '@/core/service/events'
import variables from '@/assets/styles/helpers/_variables.scss'
import { errorSnackbar, successSnackbar } from '@/core/service/utils'

// import validacao from './validacao'
// import moment from 'moment'

export default {
  name: 'ModalAprovarAfiliado',
  mixins: [validationMixin],
  directives: {mask},
  components: {
    Modal: () => import('@/views/components/modal'),
    Contratos: () => import('./contratos'),
    Referencia: () => import('./referencia'),
    ParentAffiliate: () => import('./parentAffiliate')
  },
  data: () => ({
    activeModal: false,
    loading: false,
    contrato: '',
    // comissao: '',
    afiliado: '',
    tab: 'tab-1',
    type: 'contrato',
    listaContratosAdicionados: [],
    loadingBtn: false,
    keyContratos: 1
  }),
  watch: {
  },
  computed: {
    ...mapGetters('roles', ['permiteAcao']),
    ...mapGetters('afiliadosContratos', {
      listaContratos: 'itensSelect',
      listaItensContratos: 'listaItens'
    }),
    ...mapGetters('afiliadosReferenciaComissao', {
      listaRefenreciaComissoes: 'itensSelect',
      listaItensComissoes: 'listaItens'
    }),
    ...mapGetters('afiliadosPendentes', {
      itensContratos: 'itensContratos',
      itensReferencias: 'itensReferencias',
      getParentIdAffiliate: 'getParentIdAffiliate'
    }),
    // ...validacao,
    variables: () => variables,
    isEdit () {
      return this.item.id ? !!1 : !!0
    },
    contratoSelecionado () {
      return this.listaItens.find(it => it.id === this.contrato)
    },
    comissaoSelecionado () {
      return this.listaItensComissoes.find(it => it.id === this.comissao)
    },
    errorContrato () {
      const errors = []
      if (!this.$v.contrato.$dirty) return errors
      !this.$v.contrato.required && errors.push('Campo é obrigatório.')
      return errors
    },
    types: () => [
      {
        text: 'Contrato',
        value: 'contrato'
      },
      {
        text: 'Comissão',
        value: 'comissao'
      }
    ],

    listaSelectContratos () {
      switch(this.type) {
        case 'contrato':
          return this.listaItensContratos
        case 'comissao':
            return this.listaItensComissoes
        default:
          return []
      }
    }
  },
  mounted () {
    // this.obterItensSelect()
    Events.$on('cadastro::openModalAprovarAfiliado', (e) => {
      this.afiliado = e
      this.tab = this.afiliado.jsonFlags.pendingApprovalAffiliate ? 'tab-1': 'tab-2'
      this.openModal()
    })
    Events.$on('cadastro::closeModalAprovarAfiliado', () => {
      this.closeModal()
    })
    console.log(this.listaItens, 'caiuAqui')
  },
  methods: {
    ...mapActions('afiliadosPendentes', {
      limparItem: 'limparItem',
      aprovarAfiliado: 'aprovarAfiliado',
      editarAfiliado: 'editarAfiliado'
    }),
    openModal () {
      this.activeModal = true
      this.keyContratos += 1 
      // this.obterContratos()
      // this.obterReferenciaComissoes()
    },

    closeModal () {
      this.activeModal = false
      this.limparItem()
    },

    submit () {
      const contratos = this.itensContratos.map(it => ({ contractId: it.contrato.id, payIntervalQty: it.payIntervalQty, payIntervalType: it.payIntervalType, type: 'contrato' }))
      const comissoes = this.itensReferencias.map(it => ({ contractId: it.id, type: 'comissao' }))

      if (!contratos.length) {
        this.$swal({
          icon: 'error',
          text: 'É obrigatório adicionar pelo menos um contrato',
          showCancelButton: false,
          showConfirmButton: false,
        })

        return
      }
      const contracts = [ ...contratos, ...comissoes ]
      this.loadingBtn = true
      const payload = { entityId: this.afiliado.id, contracts, parentId: this.getParentIdAffiliate }
      if (this.afiliado.jsonFlags.pendingApprovalAffiliate) {
        this.aprovarAfiliado(payload)
        .then(() => {
          successSnackbar('Afiliado aprovado com sucesso!')
          this.closeModal()
          this.$emit('atualizarListagem')
        })
        .catch((e) => errorSnackbar(e.error))
        .finally(() => {
          this.loadingBtn = false
        })
      } else {
        this.editarAfiliado(payload)
        .then(() => {
          successSnackbar('Afiliado editado com sucesso!')
          this.closeModal()
          this.$emit('atualizarListagem')
        })
        .catch((e) => errorSnackbar(e.error))
        .finally(() => {
          this.loadingBtn = false
        })
      }
    }
  },
}
</script>

<style lang="scss">
  @import './../../../../assets/styles/components/formularios';
  @import './../../../../assets/styles/components/modal-cadastro';

  .v-slide-group__content {
    background-color: #1d1d29 !important;
  }

  .v-card.v-sheet.theme--light {
    background-color: #1d1d29 !important;
  }

  strong {
    color: white;
  }

  .py-0.col.col-12 {
    color: white;
  }

  input#input-132 {
    color: #777784 !important;
  }

  div#list-126 {
   background-color: #1d1d29; 
  }

  div#list-121 {
    background-color: #1d1d29;
  }

  .v-list-item__title {
    color: #777784 !important;
  }

  .v-text-field--outlined .v-text-field__prefix, .theme--light.v-select .v-select__selection--comma, .theme--light.v-input input, .theme--light.v-input textarea, .theme--light.v-input input, .theme--light.v-input .i .theme--light.v-input input, .v-application .primary--text, .theme--light.v-input ::placeholder {
    color: #777784 !important;
  }

  .v-input__slot {
    background-color: #1d1d29 !important;
  }

  label.v-label.theme--light {
    color: #777784 !important;
  }

  .v-list-item__content {
    color: #777784 !important;
  }

  div#list-90 {
    background-color: #1d1d29 !important;
  }
</style>